<template>
	<!-- 设置团长活动机制 -->
	<el-drawer title="设置团长活动机制" size="600px" class="edit-shop" :visible.sync="visible" :before-close="handleClose">
		<el-form :model="form" ref="form" label-width="150px" class="mt-24" :rules="rules">
			<el-row>
				<el-col :span="14">
					<el-form-item label="活动佣金率" prop="product_activity_ratio">
						<span>{{ row.itemCommissionRate | formatEmpty }} %</span>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="14">
					<el-form-item prop="investmentPromotionRate">
						<span slot="label">
							<el-tooltip placement="top">
								<div slot="content">服务费率不得低于当前活动要求，<br />高于你的服务费率</div>
								<i class="iconfont icon-a-help-circle-obangzhu-xian"></i>
							</el-tooltip>
							活动服务费率
						</span>
						<el-input
							oninput="value=value.replace(/[^0-9.]/g,'')"
							v-model="form['investmentPromotionRate']"
							autocomplete="off"
							placeholder="请输入1以上的数字"
							suffix-icon="suffix-icon"
						></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="14">
					<el-form-item prop="cooperationEndTime">
						<span slot="label">合作结束时间</span>
						<el-date-picker v-model="form['cooperationEndTime']" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"> </el-date-picker>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div class="footer mt-20 fz-14">
			<div>
				<el-checkbox v-model="checked">勾选代表同意</el-checkbox>
				<a href="https://automan.jinritemai.com/docpage/views/f853dd52-c2e8-4ed4-a4a6-9ef4700210fd" target="_blank" class="yx-color-primary ml-6"
					>《招商活动服务协议》</a
				>
			</div>
			<div class="flex">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="signUp">报 名</el-button>
			</div>
		</div>
	</el-drawer>
</template>
<script>
import { activityKsApplyOne } from '@/api/secondColonelManage';
export default {
	name: 'editShopDialog',
	data() {
		return {
			visible: false,
			form: {},
			rules: {
				investmentPromotionRate: [{ required: true, message: '请输入活动服务费率', trigger: 'blur' }],
				cooperationEndTime: [{ required: true, message: '请选择合作结束时间', trigger: 'blur' }],
			},
			row: {},
			activityId: '',
			checked: false,
			authorityId: '',
		};
	},
	methods: {
		//编辑商品机制
		async show(row, activityId, authorityId) {
			this.activityId = activityId;
			this.authorityId = authorityId;
			this.row = row;
			this.visible = true;
		},
		//报名
		signUp() {
			const { activityId, form, row, authorityId: authority_id } = this;
			let cooperationEndTime = form.cooperationEndTime + ' 00:00:00';
			form.activityId = activityId;
			form.preActivityId = row.activityId;
			form.itemId = [row.itemId];
			form.authority_id = authority_id;
			this.$refs['form'].validate(async valid => {
				if (valid) {
					if (!this.checked) {
						this.$message.warning('请先勾选《招商活动服务协议》');
						return;
					}
					await activityKsApplyOne({ ...form, cooperationEndTime });
					this.$message.success('报名成功');
					this.handleClose();
					this.$emit('refresh');
				}
			});
		},
		handleClose() {
			this.form = {};
			this.$refs['form'].resetFields();
			this.visible = false;
		},
	},
};
</script>
<style lang="less" scoped>
.edit-shop {
	/deep/ .suffix-icon::after {
		content: '%';
		width: 33px;
		background-color: #f7f8fa;
		border-bottom-right-radius: 2px;
		border-top-right-radius: 2px;
	}
	/deep/ .suffix-icon-1::after {
		content: '￥';
		width: 33px;
		background-color: #f7f8fa;
		border-bottom-right-radius: 2px;
		border-top-right-radius: 2px;
	}
	/deep/ .el-input__suffix {
		height: 92%;
		right: 1px;
		top: -1px;
	}
}
::v-deep .el-drawer__header {
	padding: 16px 24px !important;
	margin: 0;
	border-bottom: 1px solid #f5f5f5;
	span {
		color: #333;
		font-weight: bold;
	}
}
::v-deep .el-drawer__body {
	padding: 0px 24px !important;
}
::v-deep .el-date-editor {
	width: 100%;
}
.footer {
	width: 100%;
	position: absolute;
	bottom: 0;
	right: 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px 20px;
	border-top: 1px solid #eeeeee;
}
</style>
